import { useEffect, useMemo } from "react";
import { getLocationOptions, getProviderOptions } from "utils";

export const useLocationsAndProvidersOptions = ({
  locations,
  providers,
  setValue,
}) => {
  const locationOptions = useMemo(
    () => getLocationOptions(locations),
    [locations]
  );
  const providerOptions = useMemo(
    () => getProviderOptions(providers),
    [providers]
  );

  const isMoreThanOneProvider = providers.length > 1;
  const isLocationsPresent = Object.keys(locationOptions)?.length > 0;

  useEffect(() => {
    if (providers.length === 1) {
      setValue("providerId", providers[0].id);
    }

    if (locations.length === 1) {
      setValue("locationId", locations[0].id);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [providers, locations]);

  return {
    locationOptions,
    providerOptions,
    isLocationsPresent,
    isMoreThanOneProvider,
  };
};
